export const GET_EVENT_SUCCESS = "GET_EVENT_SUCCESS";
export const GET_EVENT_LOAD = "GET_EVENT_LOAD";
export const GET_EVENT_FAILD = "GET_EVENT_FAILD";
export const GET_ONE_EVENT = "GET_ONE_EVENT";
